"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Spinner_1 = require("./Spinner");
exports.default = Spinner_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Spinner/index.js
// module id = 1254
// module chunks = 8